import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Link from '../Link';
import getTheme from './NavThemes';
import apiData from '../../api';
import ImagesDev from '../../api/images';
import {
  Menu, MenuSquareIcon, X,
  Search as SearchIcon, ChevronDown, Instagram, Facebook, Youtube, Music2
} from 'lucide-react';
import "./navbar.css"
import { s, sub } from 'framer-motion/client';
import { motion, AnimatePresence } from 'framer-motion';
import SearchComponent from './SearchComponent';
import MenuComponent from './MenuComponent';
import { checkLoginStatus } from '../../api/authService';
import { Toast } from '../Toast';





function Navbar({ currentPageSlug, isScrolled }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems = [
    
    isMobile ? { name: "THP Lagos 2026", url: "/healing-party" } : { name: "Home", url: "/" },
    {
      name: "About",
      url: "/about",
      subItems: [
        { name: "About", url: "/about" },
        { name: "Titothewriter", url: "/titothewriter" },
      ],
    },
    {
      name: "Ministries",
      url: "/healing-party",
      subItems: [
        { name: "Healing Party", url: "/healing-party" },
        { name: "Bible Study", url: "/bible-study" },
        { name: "Life in the Spirit", url: "/life-in-the-spirit" },
      ],
    },
    { name: "Library", url: "/library" },
    {
      name: "Events",
      url: "/pop-my-cherry",
      subItems: [
        { name: "THP Lagos 2026", url: "/healing-party" },
        { name: "Pop My Cherry", url: "/pop-my-cherry" },
        { name: "Birthday Bible Brunch", url: "/birthday-bible-brunch" },
      ],
    },
    { name: "Gallery", url: "/gallery" },
    { name: "Contact", url: "/contact" },
    isAuthenticated
      ? { name: "Profile", url: "/profile" }
      : { name: "Sign In", url: "/login" },
  ];

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const loggedIn = await checkLoginStatus();
        setIsAuthenticated(loggedIn);
      } catch (error) {
        Toast.warning("Unable to Fetch user Status: " + error)
      }
    };
    verifyUser();
  }, []);


  return isMobile ? (
    <>
      <Tags currentPageSlug={currentPageSlug} />
      <Mobile_Navbar currentPageSlug={currentPageSlug} isScrolled_={isScrolled} navItems={navItems} />
    </>
  ) : (
    <>
      <Tags currentPageSlug={currentPageSlug} />
      <Desktop_Navbar currentPageSlug={currentPageSlug} navItems={navItems} />
    </>
  );
}

const socialLinks = [
  { icon: Instagram, url: 'https://www.instagram.com/titothewriter/', label: 'Instagram' },
  { icon: Facebook, url: 'https://web.facebook.com/profile.php?id=61556604022000', label: 'Facebook' },
  { icon: Music2, url: 'https://www.tiktok.com/@titothewriter1?is_from_webapp=1&sender_device=pc', label: 'TikTok' },
  { icon: Youtube, url: 'https://www.youtube.com/@titothewriter', label: 'YouTube' }
];

function Desktop_Navbar({ currentPageSlug, navItems }) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <header
      className={`fixed w-full z-50 transition-all duration-500 ${isScrolled
        ? 'bg-black/80 backdrop-blur-lg py-2'
        : 'bg-transparent py-4'
        }`}
    >
      <nav className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          <Link to="/" className={`flex items-center space-x-0 group`}>
            <img className="w-12 h-12 transition-transform duration-300 group-hover:scale-105" src={ImagesDev.logo} />
            <div>
              <p className='px-2 leading-none pt-1 font-phosphate text-white'>
                TSO
                <br />
                MINISTRIES
              </p>
              {/* <p className='px-2 leading-none pt-0 font-allura'>Leadership Academy</p> */}
            </div>
          </Link>

          <div className="flex items-center space-x-8">
            <motion.div
              className="flex items-center space-x-1 px-8 py-0 rounded-full bg-white/5 backdrop-blur-sm border border-white/10"
              whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
            >
              <ul className="flex items-center space-x-8">
                {navItems.map((item, index) => (
                  <li
                    key={index}
                    className="relative py-3"
                    onMouseEnter={() => item.subItems && setActiveDropdown(index)}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <Link
                      to={item.url}
                      className={`flex items-center text-sm font-medium ${currentPageSlug.includes(item.name.toLowerCase())
                        ? 'text-[#FEB405]'
                        : 'text-white hover:text-orange-300'
                        } transition-colors duration-300`}
                    >
                      {item.name}
                      {item.subItems && (
                        <ChevronDown className="w-4 h-4 ml-1" />
                      )}
                    </Link>

                    {item.subItems && activeDropdown === index && (
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        transition={{ duration: 0.2 }}
                        className="absolute top-6 left-0 mt-2 w-56 py-2 bg-black/90 backdrop-blur-lg rounded-xl border border-white/10 shadow-xl"
                      >
                        {item.subItems.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.url}
                            className={`block px-4 py-2 text-sm ${currentPageSlug.includes(subItem.url.split('/')[2])
                              ? 'text-[#FEB405]'
                              : 'text-white hover:bg-white/10'
                              } transition-colors duration-200`}
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>

            <div className="flex items-center space-x-4">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  className="text-white/70 hover:text-white transition-colors duration-200"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>

            <Link
              to="/support"
              className="px-6 py-2.5 bg-gradient-to-r from-tc-gold to-orange-600 text-white text-sm font-medium rounded-full hover:scale-[1.1] transition-all duration-[800ms] shadow-lg hover:shadow-purple-500/25"
            >
              Support Us
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}

function Mobile_Navbar({ currentPageSlug, isScrolled_, navItems }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  // const location = useLocation();


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  return (
    <header className="fixed w-full z-50">
      <div className={`absolute transition-all duration-[500ms] w-[101vw] left-[-0.5vw] right-0 h-[20px] rounded-t-[20px] z-0 ${isScrolled
        ? 'opacity-1 bottom-[-76px] scale-100'
        : 'opacity-0 bottom-[-26px] scale-150'
        }`}>
        <div className={`absolute bottom-[-20px] transition-all duration-[600ms] border-t-[4px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[-16px] transition-all duration-[600ms] border-t-[8px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[-12px] transition-all duration-[600ms] border-t-[12px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[-08px] transition-all duration-[600ms] border-t-[16px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[-04px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[-00px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[+04px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[+08px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[+12px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[+16px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
        <div className={`absolute bottom-[+20px] transition-all duration-[600ms] border-t-[20px] border-black left-0 right-0 h-[100px] rounded-t-[50px] z-0`} />
      </div>


      <div className={`flex items-center transition-all duration-[600ms] justify-between px-4 py-3 ${isScrolled
        ? 'bg-black/90 backdrop-blur-lg'
        : 'bg-transparent'
        }`}>

        <Link to="/" className={`flex items-center space-x-0 group`}>
          <img className="w-12 h-12 transition-transform duration-300 group-hover:scale-105" src={ImagesDev.logo} />
          <div>
            <p className='px-2 leading-none pt-1 font-phosphate text-white'>
              TSO
              <br />
              MINISTRIES
            </p>
            {/* <p className='px-2 leading-none pt-0 font-allura'>Leadership Academy</p> */}
          </div>
        </Link>

        <div className={`flex items-center space-x-4 transition-all duration-[600ms] ${isScrolled
          ? 'bg-transparent'
          : 'bg-black/40 backdrop-blur-lg px-4 rounded-xl'
          }`}>
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsSearchOpen(true)}
            className="p-2 text-white/80 hover:text-white transition-colors"
          >
            <SearchIcon className="w-6 h-6" />
          </motion.button>
          <motion.button
            whileTap={{ scale: 0.95 }}
            onClick={() => setIsMenuOpen(true)}
            className="p-2 text-white/80 hover:text-white transition-colors"
          >
            <Menu className="w-6 h-6" />
          </motion.button>
        </div>
      </div>


      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-0 bg-black/95 backdrop-blur-lg"
          >
            <div className="flex flex-col h-full">
              <div className="flex justify-end p-4">
                <motion.button
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setIsMenuOpen(false)}
                  className="p-2 text-white/80 hover:text-white transition-colors"
                >
                  <X className="w-6 h-6" />
                </motion.button>
              </div>

              <nav className="flex-1 px-6 py-8 overflow-y-auto">
                <ul className="space-y-6">
                  {navItems.map((item, index) => (
                    <li key={index}>
                      {item.subItems ? (
                        <div>
                          <button
                            onClick={() => setActiveSubmenu(activeSubmenu === index ? null : index)}
                            className={`text-2xl font-medium flex items-center justify-between w-full ${currentPageSlug.includes(item.name.toLowerCase())
                              ? 'text-orange-400'
                              : 'text-white'
                              }`}
                          >
                            {item.name}
                            <ChevronDown
                              className={`w-5 h-5 transition-transform duration-300 ${activeSubmenu === index ? 'rotate-180' : ''
                                }`}
                            />
                          </button>
                          <AnimatePresence>
                            {activeSubmenu === index && (
                              <motion.ul
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: 'auto', opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.2 }}
                                className="mt-4 ml-4 space-y-3"
                              >
                                {item.subItems.map((subItem, subIndex) => (
                                  <motion.li
                                    key={subIndex}
                                    initial={{ x: -10, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    transition={{ delay: subIndex * 0.1 }}
                                  >
                                    <Link
                                      to={subItem.url}
                                      className={`text-lg ${currentPageSlug.includes(subItem.url.split('/')[2])
                                        ? 'text-orange-300 hover:text-orange-600'
                                        : 'text-gray-300 hover:text-white'
                                        } transition-colors`}
                                      onClick={() => setIsMenuOpen(false)}
                                    >
                                      {subItem.name}
                                    </Link>
                                  </motion.li>
                                ))}
                              </motion.ul>
                            )}
                          </AnimatePresence>
                        </div>
                      ) : (
                        <Link
                          to={item.url}
                          className={`text-2xl font-medium ${currentPageSlug.includes(item.name.toLowerCase())
                            ? 'text-orange-400'
                            : 'text-white'
                            }`}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {item.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>

              <div className="p-6 border-t border-white/10">
                <div className="flex justify-center space-x-6 mb-6">
                  {socialLinks.map((social, index) => (
                    <motion.a
                      key={index}
                      href={social.url}
                      className="text-white/70 hover:text-white transition-colors"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.95 }}
                      aria-label={social.label}
                    >
                      <social.icon className="w-6 h-6" />
                    </motion.a>
                  ))}
                </div>
                <Link
                  to="/support"
                  className="block w-full py-3 text-center bg-gradient-to-r from-tc-gold to-orange-600 text-white font-medium rounded-full hover:scale-[1.1] transition-all duration-[800ms]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Support Us
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {isSearchOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/95 backdrop-blur-lg p-4"
          >
            <div className="flex justify-end mb-4">
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsSearchOpen(false)}
                className="p-2 text-white/80 hover:text-white transition-colors"
              >
                <X className="w-6 h-6" />
              </motion.button>
            </div>
            <div className="max-w-xl mx-auto">
              <div className="relative">
                <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search..."
                  className="w-full pl-12 pr-4 py-3 bg-white/10 text-white placeholder-gray-400 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-300"
                  autoFocus
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}








const getDescriptions = (currentPageSlug) => {
  const site = "Welcome to Titoluwa Olumideko Ministries (TSO Ministries), a ministry built on faith, love, and purpose. Till every eye sees Jesus!";
  const titothewriter = "Learn more about Titoluwa Olumideko — also known as TitoTheWriter — the visionary founder of TSO Ministries, a mission rooted in love, faith, and purpose."

  const description = currentPageSlug === "titothewriter" ? titothewriter : site;
  return description
}

const getTitle = (currentPageSlug) => {
  const _default = "TSO Ministries – " + currentPageSlug;
  const site = "TSO Ministries – Titoluwa Olumideko Ministries";
  const titothewriter = "About Titoluwa “TitoTheWriter” Olumideko | TSO Ministries"

  const description = currentPageSlug === "hello-world" ? site :
    currentPageSlug === "titothewriter" ? titothewriter :
      _default;
  return description
}

const getKeywords = (currentPageSlug) => {
  const site = `TSO Ministries, Titoluwa Ministries, Titoluwa Ministries, TitoTheWritter, 
  TitoTheWriter, Titoluwa Olumideko Ministries, Titoluwa Olumideko Ministries, 
  tsoministries, Tito Oladapo, tsoministries.com`;

  const titothewriter = `TitoTheWriter, TitoTheWriter, Titoluwa Ministries, 
  Titoluwa Olumideko, TSO Ministries, Titoluwa Olumideko Ministries, About Tito The Writer`

  const description = currentPageSlug === "titothewriter" ? titothewriter : site;
  return description
}



const Tags = ({ currentPageSlug }) => {
  const siteDescription = getDescriptions(currentPageSlug);
  const siteKeywords = getKeywords(currentPageSlug);
  const pageTitle = getTitle(currentPageSlug);

  return (
    <Helmet>
      <script type="application/ld+json">
        {`
      {
        "@context": "https://schema.org",
        "@type": "Person",
        "name": "Titoluwa Olumideko",
        "alternateName": [
          "TitoTheWriter",
          "Titoluwa Ministries",
          "TSO Ministries"
        ],
        "url": "https://tsoministries.com",
        "sameAs": [
          "https://web.facebook.com/profile.php?id=61556604022000",
          "https://www.instagram.com/titothewriter/",
          "https://twitter.com/titothewriter",
          "https://www.youtube.com/@titothewriter",
          "https://www.tiktok.com/@titothewriter1"
        ]
      }
    `}
      </script>
      <title>{pageTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />
      <meta name="author" content="Titoluwa Olumideko" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:url" content="https://tsoministries.com" />
      <meta property="og:image" content="https://tsoministries.com/wp-content/uploads/2025/04/bbb.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="google-site-verification" content="Nduh505PudP9nCT9kXFeHjtRnVCaV2dbvZolbrZhgsw" />
    </Helmet>
  )
}



export default Navbar;











